import { Injectable } from "@angular/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { BehaviorSubject, Observable } from "rxjs";
import { BaseService } from "../shared/services/base.service";
import { ExcelDownloadService } from "../shared/services/excel-download.service";
import * as config from '../shared/config/app.config';

@Injectable({
  providedIn: 'root'
})
export class CustomCustomerServiceBrService {
  userId: any;
  ticketCategories:any;
  ticketsToDisplay=new BehaviorSubject(false);
  ticketStatus:any
  viewTicketDetails = new BehaviorSubject(false);
  ticketCreated:any;
  ticketCreationError:any;
  ticketUpdated = new BehaviorSubject(false);
  ticketUpdationError = new BehaviorSubject(false);

  constructor(private readonly baseService: BaseService, private readonly user: UserAccountFacade,
    public excelService: ExcelDownloadService) {
  }

  getTicketCategories(): void {
    this.ticketCategories=new BehaviorSubject(false);
    this.baseService.get(`${config.GET_TICKET_CATEGORIES}`).subscribe((res) => {
      if (res) {
        this.ticketCategories.next(res);
      }
    });
  }
  getTicketStatus():void{
    this.ticketStatus=new BehaviorSubject(false);
    this.baseService.get(`/enumeration?enumerationType=CsticketState&fields=DEFAULT`).subscribe((res) => {
      if (res) {
        this.ticketStatus.next(res);
      }
    });
  }
  subTicketCategories(): Observable<any> {
    return this.baseService.get(`${config.GET_SUB_TICKET_CATEGORIES}`);
  }
  createTicketDetails(params): void {
    this.ticketCreated=new BehaviorSubject(false);
    this.ticketCreationError=new BehaviorSubject(false);
    this.baseService.post(`${config.USER_ACCOUNT}current/tickets`, params).subscribe((res) => {
      if (res) {
        this.ticketCreated.next(res);
      }
    },
      (err) => {
        this.ticketCreationError.next(err);
      });
  }
  updateTicketDetails(params,ticketId): void {
    this.user.get().subscribe((res: any) => {
      if (res) {
        this.userId = res?.userName;
      }
    });
    this.baseService.post(`${config.USER_ACCOUNT}/${this.userId}/updateTicket?fields=DEFAULT&ticketId=${ticketId}`, params).subscribe((res) => {
      if(res){
        this.ticketUpdated.next(res);
      }
    },
    (err) => {
      this.ticketUpdationError.next(err);
    });
  }

  getTicketsToDisplay(userId,params) {
    this.baseService.get(`/users/${userId}/tickets?fields=DEFAULT&${params}`).subscribe((res) => {
      if (res) {
        this.ticketsToDisplay.next(res);
      }
    });
  }
  getTicketDetails(ticketId, userId){
    this.baseService.get(`/users/${userId}/tickets/${ticketId}`).subscribe((res)=>{
      if(res){
        this.viewTicketDetails.next(res);
      }
    })
  }
  public downloadXls(data, name) {
    this.excelService.exportAsExcelFile(data, name, true);
  }
}
